import React, { useEffect } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import "../assets/css/venobox.css";
import "../assets/css/style.css";
import UrlParamChecker from "../component/UrlChecker";

const Contact = () => {
  return (
    <div>
      <NavBar />
      <main id="main">
        <section id="contact" className="innerPage" style={UrlParamChecker() ? { marginTop: "16px", paddingTop: "0" } : {}}>
          <div className="container">
            <div className="section-title">
              <h2>Contact Us</h2>
            </div>
            <div className="row">
              {/* <!-- <div className="col-md-4 d-flex">
                <div style="width: 100%;">
                    <h6>RBI Contact Details</h6>
                    <p><i className="ri-phone-line"></i> <a href="tel:+022-22603456">022-22603456</a></p>
                    <p><i className="ri-phone-line"></i> <a href="tel:+022-22603457">022-22603457</a></p>
                    <p><i className="ri-mail-line"></i> <a href="mailto:retaildirect@rbi.org.in">retaildirect@rbi.org.in</a></p>
                </div>
            </div> --> */}

              <div className="col-md-4 d-flex">
                <div style={{ width: '100%' }}>
                  <h6>RBI Retail Direct Support</h6>
                  <p>
                    <i className="ri-phone-line"></i>{" "}
                    <i className="ri-arrow-right-up-line" style={{ color: 'limegreen', marginLeft: '-4px' }}></i>
                    <a href="tel:1800 267  7955" title="Out-Bound Number">1800 267 7955</a>
                  </p>
                  <p>
                    <i className="ri-phone-line"></i>
                    <i className="ri-arrow-left-down-line" style={{ color: 'red', marginLeft: '-4px' }}></i>
                    <a href="tel:+91-22-61546335" title="In-Bound Number">+91-22-61546335</a>
                  </p>
                  <p>
                    <i className="ri-mail-line"></i>{" "}
                    <a href="mailto:support@rbiretaildirect.org.in">
                      support@rbiretaildirect.org.in
                    </a>
                  </p>
                  <p>
                    <i className="ri-time-line"></i>{" "}
                    <a style={{ color: '#000' }}>10am - 6pm (Monday - Saturday)</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer footerClass="footerFixed" />
    </div>
  )
}; export default Contact;
